const NO_RIGHTS_STAKEHOLDER_ID = -1;

export {NO_RIGHTS_STAKEHOLDER_ID};
